import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { EventsApiService } from 'features/events';
import { queryClient } from 'providers';

import { eventsQueryKeys } from './query-keys';

const { createTrack } = EventsApiService();

export const useCreateTrack = (id: any) => {
    const { message } = App.useApp();

    return useMutation(
        (payload: any) => {
            return createTrack(payload);
        },
        {
            onError: (error) => {
                const uiMessage = handleError(error);

                message.error(uiMessage);
            },
            onSuccess: () => {
                queryClient.invalidateQueries({
                    queryKey: eventsQueryKeys.all,
                });
                if (id) {
                    message.success("Race Track has been updated successfully!!");
                } else {
                    message.success("Race Track has been created successfully!!");
                }
            },
        },
    );
};
